"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KiconnectService = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _v = _interopRequireDefault(require("uuid/v4"));

var KiconnectService = /*#__PURE__*/function () {
  function KiconnectService(config) {
    (0, _classCallCheck2.default)(this, KiconnectService);
    this.config = config;
  }

  (0, _createClass2.default)(KiconnectService, [{
    key: "getAccessToken",
    value: function getAccessToken() {
      var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var error = this.extractError(redirectUrl);

      if (error) {
        throw new Error(error);
      }

      return this.extractSession(redirectUrl);
    }
  }, {
    key: "extractError",
    value: function extractError() {
      var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var explicit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var errorMatch = redirectUrl.match(/(?:[?&#/]|^)error=([^&]+)/);

      if (!errorMatch) {
        return undefined;
      }

      var errorReason = errorMatch[1];
      var errorDescriptionMatch = redirectUrl.match(/(?:[?&#/]|^)error_description=([^&]+)/);
      var errorDescription = errorDescriptionMatch ? errorDescriptionMatch[1] : '';

      if (explicit) {
        return {
          errorReason: errorReason,
          errorDescription: errorDescription
        };
      }

      return "Error during login. Reason: ".concat(errorReason, " Description: ").concat(errorDescription);
    }
  }, {
    key: "extractSession",
    value: function extractSession() {
      var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var accessToken = null;
      var decodedAccessToken = null;
      var accessTokenMatch = redirectUrl.match(/(?:[?&#/]|^)access_token=([^&]+)/);

      if (accessTokenMatch) {
        accessToken = accessTokenMatch[1];
        decodedAccessToken = JSON.parse(atob(accessToken.split('.')[1]));
      }

      var expireDurationSeconds = 3600;
      var expireDurationSecondsMatch = redirectUrl.match(/expires_in=([^&]+)/);

      if (expireDurationSecondsMatch) {
        expireDurationSeconds = parseInt(expireDurationSecondsMatch[1], 10);
      }

      return {
        accessToken: accessToken,
        decodedAccessToken: decodedAccessToken,
        expireDurationSeconds: expireDurationSeconds
      };
    }
  }, {
    key: "extractIdToken",
    value: function extractIdToken() {
      var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var idToken = null;
      var decodedIdToken = null;
      var idTokenMatch = redirectUrl.match(/id_token=([^&]+)/);

      if (idTokenMatch) {
        idToken = idTokenMatch[1];
        decodedIdToken = JSON.parse(atob(idToken.split('.')[1]));
      }

      return {
        idToken: idToken,
        decodedIdToken: decodedIdToken
      };
    }
  }, {
    key: "getAuthorizeUrl",
    value: function getAuthorizeUrl() {
      var state = (0, _v.default)();
      var nonce = (0, _v.default)();
      var _this$config = this.config,
          IDENTITY_SERVER_URL = _this$config.IDENTITY_SERVER_URL,
          CLIENT_ID = _this$config.CLIENT_ID,
          REDIRECT_URI = _this$config.REDIRECT_URI,
          SCOPES = _this$config.SCOPES;
      return "".concat(IDENTITY_SERVER_URL, "/connect/authorize?client_id=").concat(encodeURIComponent(CLIENT_ID), "&redirect_uri=").concat(encodeURIComponent(REDIRECT_URI), "&scope=").concat(encodeURIComponent(SCOPES), "&state=").concat(encodeURIComponent(state), "&response_type=token&nonce=").concat(encodeURIComponent(nonce));
    }
  }, {
    key: "getSignOutUrl",
    value: function getSignOutUrl() {
      var _this$config2 = this.config,
          IDENTITY_SERVER_URL = _this$config2.IDENTITY_SERVER_URL,
          POST_LOGOUT_URI = _this$config2.POST_LOGOUT_URI;
      return "".concat(IDENTITY_SERVER_URL, "/account/logout?post_logout_redirect_uri=").concat(encodeURIComponent(POST_LOGOUT_URI));
    }
  }]);
  return KiconnectService;
}();

exports.KiconnectService = KiconnectService;
//# sourceMappingURL=kiconnect-service.js.map